import { useUserProfileSelector } from "@redux/reducers/deal";

export const useResolvedRegistrationPostalCode = () => {
  const profile = useUserProfileSelector() || {};
  return (
    profile.registrationPostalCode ||
    profile.deliveryPostCode ||
    profile.billingPostCode ||
    null
  );
};
